import getApiInstance from '@/api';
import { createAsyncThunk } from '@/store/utils';

export const sendPasswordResetLink = createAsyncThunk<object, string>(
  'reset-password/sendPasswordResetLink',
  async (email) => {
    const api = (await getApiInstance()).customerProfileApi;

    return await api.CustomerProfilePasswordsReset_SendResetLink(null, {
      email,
    });
  }
);

export const resetPassword = createAsyncThunk<
  object,
  { password: string; passwordResetHash: string }
>('reset-password/resetPassword', async ({ password, passwordResetHash }) => {
  const api = (await getApiInstance()).customerProfileApi;

  return await api.CustomerProfilePasswordsReset_ResetPassword(null, {
    passwordResetHash,
    password,
  });
});
